export enum EFilterType {
	date = 'date',
	dateRange = 'dateRange',
	input = 'input',
	numberRange = 'numberRange',
	selectSingle = 'selectSingle',
  selectMultiple = 'selectMultiple',
}